import React, { Suspense, useMemo, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { WorkspaceAlarmsAction } from './WorkspaceAlarmsAction';
import WorkspaceCommanderStatusAction from './WorkspaceCommanderStatusAction';
import WorkspaceAPI from '../../../../../redux/workspace/WorkspaceAPI';
import { skipToken } from '@reduxjs/toolkit/query';
import { WorkspaceAPIResponse } from '../../../../../redux/workspace/WorkspaceAPI.model';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RemoveWorkspaceModal } from '../RemoveWorkspaceModal';
import WorkspaceAdminActions from '../WrokspaceAdminActions';
import { useAppSelector } from '../../../../../redux/store.model';
import { getHasEditWorkspaceRightSelector } from '../../../../../redux/rights/selectors/rights.selector';

export interface WorkspaceActionsProps {
  workspace: WorkspaceAPIResponse | undefined;
  // usually on header, but on items is not needed
  active?: boolean;
}

export interface WorkspaceActionsInProps {
  workspaceId: string | undefined;
  // usually on header, but on items is not needed
  active?: boolean;
}

function WorkspaceActions(props: WorkspaceActionsInProps) {
  const { workspaceId } = props;
  const { data: workspace } = WorkspaceAPI.useGetWorkspaceByIdQuery(
    workspaceId ?? skipToken
  );
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [displayConfirmModal, setDisplayConfirmModal] = useState(false);
  const hasEditRight = useAppSelector((state) =>
    getHasEditWorkspaceRightSelector(state, {
      workspaceId: workspace?.parentId || '',
    })
  );

  const menuOptionsDisplayed = useMemo(() => {
    const menuOptions = [
      {
        label: t('workspaces.edit'),
        onClick: () => {
          navigate(`/markets/${workspaceId}/edit`);
        },
        show: hasEditRight,
      },
      {
        label: t('workspaces.delete_workspace'),
        onClick: () => {
          setDisplayConfirmModal(true);
        },
        show: hasEditRight,
      },
    ];
    return menuOptions.filter((option) => option.show);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEditRight, workspaceId]);

  return (
    <Stack direction={'row'} spacing={1}>
      <Suspense fallback={null}>
        <WorkspaceCommanderStatusAction {...props} workspace={workspace} />
      </Suspense>
      <Box
        sx={{
          width: '6rem',
          height: '3rem',
        }}
      >
        <WorkspaceAlarmsAction {...props} workspace={workspace} />
      </Box>
      {menuOptionsDisplayed.length > 0 ? (
        <WorkspaceAdminActions options={menuOptionsDisplayed} />
      ) : (
        <Box
          sx={{
            width: '3rem',
          }}
        ></Box>
      )}
      <RemoveWorkspaceModal
        displayConfirmModal={displayConfirmModal}
        setDisplayConfirmModal={setDisplayConfirmModal}
        workspaceId={workspaceId || ''}
      />
    </Stack>
  );
}

export default WorkspaceActions;
